// Action Types
export const actionTypes = {
  GET_PROFILE_REQUEST: "GET_PROFILE_REQUEST",
  GET_PROFILE_REQUEST_SUCCESS: "GET_PROFILE_REQUEST_SUCCESS",
  GET_PROFILE_REQUEST_FAILED: "GET_PROFILE_REQUEST_FAILED",

  GET_INCENTIVE: "GET_INCENTIVE",
  GET_INCENTIVE_SUCCESS: "GET_INCENTIVE_SUCCESS",
  GET_INCENTIVE_FAILED: "GET_INCENTIVE_FAILED",

  GET_KNOWLEDGE_CENTER: "GET_KNOWLEDGE_CENTER",
  GET_KNOWLEDGE_CENTER_SUCCESS: "GET_KNOWLEDGE_CENTER_SUCCESS",
  GET_KNOWLEDGE_CENTER_FAILED: "GET_KNOWLEDGE_CENTER_FAILED",

  POST_KNOWLEDGE_CENTER: "POST_KNOWLEDGE_CENTER",
  POST_KNOWLEDGE_CENTER_SUCCESS: "POST_KNOWLEDGE_CENTER_SUCCESS",
  POST_KNOWLEDGE_CENTER_FAILED: "POST_KNOWLEDGE_CENTER_FAILED",

  POST_INCENTIVE: "POST_INCENTIVE",
  POST_INCENTIVE_SUCCESS: "POST_INCENTIVE_SUCCESS",
  POST_INCENTIVE_FAILED: "POST_INCENTIVE_FAILED",
  //folder
  GET_KNOWLEDGE_CENTER_FOLDER: "GET_KNOWLEDGE_CENTER_FOLDER",
  GET_KNOWLEDGE_CENTER_FOLDER_SUCCESS: "GET_KNOWLEDGE_CENTER_FOLDER_SUCCESS",
  GET_KNOWLEDGE_CENTER_FOLDER_FAILED: "GET_KNOWLEDGE_CENTER_FOLDER_FAILED",
};

// Reducer
const initialState = {
  profile: null,
  isLoading: false,
  errors: null,
  incentive: [],
  knowledgeCenter: [],
  isLoadingPostKnowledgeCenter: false,
  isLoadingGetKnowledgeCenter: false,
  isLoadingGetIncentive: false,
  isLoadingPostIncentive: false,

  //folder
  knowledgeCenterFolder: [],
  isGettingFolder: false,
};

export const actionCreators = {
  getKnowledgeCenterFolder: () => ({
    type: actionTypes.GET_KNOWLEDGE_CENTER_FOLDER,
  }),

  getProfileRequest: () => ({ type: actionTypes.GET_PROFILE_REQUEST }),

  getIncentive: () => ({ type: actionTypes.GET_INCENTIVE }),

  getKnowledgeCenter: () => ({ type: actionTypes.GET_KNOWLEDGE_CENTER }),

  postKnowledgeCenterFavorite: params => ({
    type: actionTypes.POST_KNOWLEDGE_CENTER,
    params
  }),

  postIncentiveFavorite: params => ({
    type: actionTypes.POST_INCENTIVE,
    params
  })
};

export default (state = initialState, action) => {
  switch (action.type) {

    //folder
    case actionTypes.GET_KNOWLEDGE_CENTER_FOLDER:
      return Object.assign({}, state, {
        isGettingFolder: true,
        error: null,
      });

    case actionTypes.GET_KNOWLEDGE_CENTER_FOLDER_SUCCESS:
      return Object.assign({}, state, {
        isGettingFolder: false,
        error: null,
        knowledgeCenterFolder: action.payload ? action.payload : [],
      });

    case actionTypes.GET_KNOWLEDGE_CENTER_FOLDER_FAILED:
      return Object.assign({}, state, {
        isGettingFolder: false,
        error: action.error,
        knowledgeCenterFolder: [],
      });
    //
    case actionTypes.GET_KNOWLEDGE_CENTER:
      return Object.assign({}, state, {
        isLoadingGetKnowledgeCenter: true,
        errors: null
      });

    case actionTypes.GET_KNOWLEDGE_CENTER_SUCCESS:
      return Object.assign({}, state, {
        isLoadingGetKnowledgeCenter: false,
        errors: null,
        knowledgeCenter: action.payload
      });

    case actionTypes.GET_KNOWLEDGE_CENTER_FAILED:
      return Object.assign({}, state, {
        isLoadingGetKnowledgeCenter: false,
        errors: action.errors,
        knowledgeCenter: []
      });

    case actionTypes.GET_INCENTIVE:
      return Object.assign({}, state, {
        isLoadingGetIncentive: true,
        errors: null
      });

    case actionTypes.GET_INCENTIVE_SUCCESS:
      return Object.assign({}, state, {
        isLoadingGetIncentive: false,
        errors: null,
        incentive: action.payload
      });

    case actionTypes.GET_INCENTIVE_FAILED:
      return Object.assign({}, state, {
        isLoadingGetIncentive: false,
        errors: action.errors,
        incentive: null
      });

    case actionTypes.GET_PROFILE_REQUEST:
      return Object.assign({}, state, { isLoading: true, errors: null });

    case actionTypes.GET_PROFILE_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        isLoading: false,
        errors: null,
        profile: action.profile
      });

    case actionTypes.GET_PROFILE_REQUEST_FAILED:
      return Object.assign({}, state, {
        isLoading: false,
        errors: action.errors,
        profile: null
      });

    case actionTypes.POST_KNOWLEDGE_CENTER:
      return Object.assign({}, state, {
        isLoadingPostKnowledgeCenter: true,
        errors: null
      });

    case actionTypes.POST_KNOWLEDGE_CENTER_SUCCESS:
      return Object.assign({}, state, {
        isLoadingPostKnowledgeCenter: false,
        errors: null,
        knowledgeCenter: state.knowledgeCenter.map(item =>
          item.id === action.payload.id
            ? {
                ...item,
                favorite: action.payload.favorite
              }
            : item
        )
      });

    case actionTypes.POST_KNOWLEDGE_CENTER_FAILED:
      return Object.assign({}, state, {
        isLoadingPostKnowledgeCenter: false,
        errors: action.errors,
        knowledgeCenter: []
      });

    case actionTypes.POST_INCENTIVE:
      return Object.assign({}, state, {
        isLoadingPostIncentive: true,
        errors: null
      });

    case actionTypes.POST_INCENTIVE_SUCCESS:
      return Object.assign({}, state, {
        isLoadingPostIncentive: false,
        errors: null,
        incentive: state.incentive.map(item =>
          item.id === action.payload.id
            ? {
                ...item,
                favorite: action.payload.favorite
              }
            : item
        )
      });

    case actionTypes.POST_INCENTIVE_FAILED:
      return Object.assign({}, state, {
        isLoadingPostIncentive: false,
        errors: action.errors,
        incentive: []
      });

    default:
      return state;
  }
};
